module.exports = __webpack_public_path__ + "static/sunriver_st_george-7c5e9e4954ef4b8a2e68fc822f87df10.jpg";